import ProductFunctions from '@/models/ProductFunctions';

export default class ProductFunctionsRepository {
    public static getAll() {
        return ProductFunctions.query().withAllRecursive().get();
    }
}
